import { Menu } from "element-ui";

const state = {
  productList: [],
  current: 0,
  Menuid: "",
};

const mutations = {
  SET_PRODUCTLIST(state, productList) {
    state.productList = productList;
  },
  SET_current(state, current) {
    state.current = current;
  },
  SET_Menuid(state, Menuid) {
    state.Menuid = Menuid;
  },
};

const actions = {};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
